import { useContext } from "react";
import { StockCountCompletedContext } from "./context";

export const useStockCountCompletedContext = () => {
  const context = useContext(StockCountCompletedContext);

  if (!context) {
    throw new Error(
      "useStocktakeCompletedContext must be used within a StocktakeCompletedContextProvider"
    );
  }

  return context;
};
